import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import { addListToDropdown, createDropdown } from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import DropdownButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/dropdownbuttonview";
import InsertVar from './command.js';

export default class VarSelect extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add('insertVar', new InsertVar(editor));
    editor.ui.componentFactory.add("VarSelect", locale => {
      const dropdownView = createDropdown(locale, DropdownButtonView);
      dropdownView.buttonView.set({
        withText: true,
        label: "Add field",
        tooltip: true
      });

      const items = new Collection();

      let itemMapping = {
        "Full Name": "##fullname##",
        "First Name": "##firstname##",
        "Middle Name": "##middlename##",
        "Last Name": "##lastname##",
        "Prefix": "##prefix##",
        "Suffix": "##suffix##",
        "Description": "##description##",
        "Company Name": "##company##",
        "Phone": "##phone##",
        "Mobile": "##mobile##",
        "Country": "##addresscountry##",
        "City": "##addresscity##",
        "Postal Code": "##addresszipcode##",
        "Street Address": "##addressstreet##",
        "Company Phone": "##companyphone##",
        "Company Website": "##url##",
        "Job Title": "##jobtitle##",
        "Department": "##department##",
        "Office": "##office##",
        "Email": "##email##",
        "Fax": "##fax##",
      }

      Object.keys(itemMapping).forEach(item => items.add({
        type: "button",
        model: new Model({
          withText: true,
          label: item,
          bodyText: itemMapping[item],
        })
      }));

      // items.add({
      //   type: "button",
      //   model: new Model({
      //     withText: true,
      //     label: "Full name",
      //     bodyText: '## fullname ##',
      //   })
      // });
      //
      // items.add({
      //   type: "button",
      //   model: new Model({
      //     withText: true,
      //     label: "First name",
      //     bodyText: '## firstname ##',
      //   })
      // });

      dropdownView.on( 'execute', (event) => {
        editor.model.change(writer => {
          writer.insertText(event.source.bodyText, editor.model.document.selection.getFirstPosition());
        })
		  });
      addListToDropdown(dropdownView, items);

      return dropdownView;
    });
  }
}



// CKEDITOR.plugins.add('var-select', {
//   icons: 'var-select',
//   init: function( editor ) {
//     console.log(editor.ui.componentFactory.names())
//   }
// });
